export const phoneNumberMeta: Record<string, Record<string, any>> = {
  AR: {
    phoneCountry: '+549',
    selectLabel: 'Argentina (+549)',
    // Valida celulares argentinos sin 0 ni 15, usando el prefijo internacional +54 9.
    regexValidation: /^(?:11\d{8}|[23]\d{9})$/,
    helpText: 'Ingrese el número sin el 0 y sin el 15',
  },
  BR: {
    phoneCountry: '+55',
    selectLabel: 'Brasil (+55)',
    // Valida celulares brasileños con DDD existente y número móvil de 9 dígitos.
    regexValidation:
      /^(?:1[1-9]|2[12478]|3[1-578]|4[1-9]|5[1345]|6[1-9]|7[134579]|8[1-9]|9[1-9])9\d{8}$/,
    helpText: 'Ingrese el número con el formato AA 9 NNNN NNNN',
  },
  DE: {
    phoneCountry: '+49',
    selectLabel: 'Alemania (+49)',
    // Valida móviles alemanes sin el 0 inicial, respetando longitudes por subrango.
    regexValidation: /^(?:15\d{9}|160[0-8]\d{6}|1609\d{7}|16[23]\d{7}|17[0-57-9]\d{7}|176\d{8})$/,
    helpText: 'Ingrese el número sin el 0 inicial',
  },
  ES: {
    phoneCountry: '+34',
    selectLabel: 'España (+34)',
    // Móviles en España empiezan con 6 o 7 y tienen 9 dígitos
    regexValidation: /^[67]\d{8}$/,
    helpText: 'Ingrese el número con el formato 6/7 NNN NNN NNN',
  },
  PY: {
    phoneCountry: '+595',
    selectLabel: 'Paraguay (+595)',
    // Valida celulares paraguayos sin el 0 inicial nacional.
    regexValidation: /^9\d{8}$/,
    helpText: 'Ingrese el número con el formato 9 NN NNNNNN',
  },
  UR: {
    phoneCountry: '+598',
    selectLabel: 'Uruguay (+598)',
    // Valida celulares uruguayos de 8 dígitos, sin el 0 inicial histórico.
    regexValidation: /^9\d{7}$/,
    helpText: 'Ingrese el número con el formato 9N NNN NNN',
  },
  CH: {
    phoneCountry: '+569',
    selectLabel: 'Chile (+569)',
    // Chile usa +56 9 para móviles; el usuario ingresa los 8 dígitos restantes.
    regexValidation: /^\d{8}$/,
    helpText: 'Ingrese el número con el formato NN NNN NNN',
  },
  BO: {
    phoneCountry: '+591',
    selectLabel: 'Bolivia (+591)',
    // Valida celulares bolivianos de 8 dígitos que comienzan con 6 o 7.
    regexValidation: /^[67]\d{7}$/,
    helpText: 'Ingrese el número con el formato [6|7] NN NNNNN',
  },
  US: {
    phoneCountry: '+1',
    selectLabel: 'Estados Unidos (+1)',
    // Valida NANP: NPA-NXX-XXXX, donde NPA y NXX no comienzan con 0 ni 1.
    regexValidation: /^[2-9]\d{2}[2-9]\d{6}$/,
    helpText: 'Ingrese el número con el formato NNN NNN NNNN',
  },
};

// Metadata: normaliza la entrada visible para validar formatos tipeados con espacios o guiones.
export const normalizePhoneNumber = (value: string) => value.replace(/\D/g, '');

// Metadata: concentra la validación para que todos los formularios usen el mismo criterio por país.
export const isValidPhoneNumber = (countryCode: string | number, value: string) => {
  const normalizedValue = normalizePhoneNumber(value);
  const { regexValidation } = phoneNumberMeta[countryCode] || {};

  return !regexValidation || regexValidation.test(normalizedValue);
};

// Enum por IDs de país (según listado provisto)
// Claves = códigos internos usados en phoneNumberMeta
export enum Country {
  AR = 1, // Argentina
  BR = 3, // Brasil
  DE = 9, // Alemania
  ES = 7, // España
  PY = 4, // Paraguay
  UR = 2, // Uruguay
  CH = 5, // Chile
  US = 6, // Estados Unidos
  // BO // Bolivia: no incluida en el listado provisto
}
